import React from "react";
import { copy } from "shared/assets";
import { Loader } from "shared/components";
import { Spacer } from "shared/layout";
import { MutedDarkText, TinyText } from "shared/styles";
import { IImageItem, IImageStylePreset } from "shared/types";
import { getImageURLWithStyle } from "shared/utils";

import {
  StyledImageGalleryItem,
  StyledImageContainer,
  StyledImage,
  StyledDescription,
} from "./styles";

export interface ImageGalleryItemProps extends IImageItem {
  currentIndex: number;
  nbItems: number;
}

export const ImageGalleryItem: React.FC<ImageGalleryItemProps> = ({
  imageStyles,
  description,
  currentIndex,
  nbItems,
}) => (
  <StyledImageGalleryItem>
    <StyledImageContainer>
      <Loader data-loader />
      <StyledImage
        data-testid="gallery_modal_image"
        data-background={getImageURLWithStyle({
          imageStyles,
          style: IImageStylePreset.galleryImage,
        })}
      />
    </StyledImageContainer>
    <StyledDescription>
      <Spacer size="s">
        <TinyText as={MutedDarkText} data-testid="gallery_modal_counter">
          {copy.imageGallery.counterLabel} {currentIndex + 1}/{nbItems}
        </TinyText>
        <p data-testid="gallery_modal_description">{description}</p>
      </Spacer>
    </StyledDescription>
  </StyledImageGalleryItem>
);
